import { ChangeEvent, forwardRef, memo, useContext } from 'react';
import { FormControlContext } from '@/components/FormControl';
import * as styles from '@/styles/components/Input';

type Input = JSX.IntrinsicElements['input'] & {
  before?: React.ReactNode;
  after?: React.ReactNode;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  disabledColor?: string;
  disabledBgColor?: string;
  disabledBorder?: string;
  padding?: string;
};

const Input = forwardRef<HTMLInputElement, Input>(function Input(
  {
    value,
    disabled,
    before,
    after,
    handleChange,
    disabledColor,
    disabledBgColor,
    disabledBorder,
    padding,
    ...props
  }: Input,
  ref,
) {
  const { invalid } = useContext(FormControlContext);
  const blockInvalidChar = (e: { key: string; preventDefault: () => any }) =>
    props?.min === 0 && ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault();
  return (
    <div
      css={styles.root(props?.width, disabledBorder, props?.height)}
      aria-disabled={disabled}
      aria-invalid={invalid}
      data-testid='input'>
      {before && <div>{before}</div>}
      <input
        ref={ref}
        css={styles.input({ disabledColor, disabledBgColor, padding })}
        // defaultValue={value}
        value={value}
        onKeyDown={blockInvalidChar}
        onChangeCapture={handleChange}
        disabled={disabled}
        {...props}
      />
      {after && <div>{after}</div>}
    </div>
  );
});

export default memo(Input);
